export const ModuleEndpoints = {
    getModule: (moduleId) => {
        return `${process.env.API_CLUB_CONTENT}/v4/modules/${moduleId}`;
    },
    createModule: () => {
        return `${process.env.API_CLUB_CONTENT}/v4/modules`;
    },
    updateModule: (moduleId) => {
        return `${process.env.API_CLUB_CONTENT}/v4/modules/${moduleId}`;
    },
    getClassDrippingStatus: (moduleId) => {
        return `${process.env.API_CLUB_CONTENT}/v4/modules/${moduleId}/pages/classes/dripping-status`;
    }
};
